export var CallSystemType;
(function (CallSystemType) {
    CallSystemType["WEBRTC"] = "ACTIVE_CALL:WEBRTC";
    CallSystemType["CLICK2CALL"] = "ACTIVE_CALL:CLICK2CALL";
    CallSystemType["PERT"] = "ACTIVE_CALL:PERT";
    CallSystemType["REST"] = "ACTIVE_CALL:REST";
})(CallSystemType || (CallSystemType = {}));
/**
 * Indicates whether you received a call (INBOUND) or you made a call (OUTBOUND)
 */
export var CallDirection;
(function (CallDirection) {
    CallDirection["INBOUND"] = "ACTIVE_CALL:INBOUND";
    CallDirection["OUTBOUND"] = "ACTIVE_CALL:OUTBOUND";
})(CallDirection || (CallDirection = {}));
/**
 * The current connection state of the call.
 *
 * An inbound call is CONNECTING until
 * you answer, at which point you are CONNECTED.
 *
 * An outbound call is DIALING, then we receive CONNECTING state
 * until the call has been answered, at which point it becomes CONNECTED.
 *
 *
 * The call is DISCONNECTED whenever either part hangs up and ends the call.
 */
export var CallConnectionState;
(function (CallConnectionState) {
    CallConnectionState["DIALING"] = "ACTIVE_CALL:DIALING";
    CallConnectionState["CONNECTING"] = "ACTIVE_CALL:CONNECTING";
    CallConnectionState["CONNECTED"] = "ACTIVE_CALL:CONNECTED";
    CallConnectionState["DISCONNECTED"] = "ACTIVE_CALL:DISCONNECTED";
    CallConnectionState["RINGING_IN_MEDIA"] = "ACTIVE_CALL:RINGING_IN_MEDIA";
    CallConnectionState["RINGING_NOT_IN_MEDIA"] = "ACTIVE_CALL:RINGING_NOT_IN_MEDIA";
})(CallConnectionState || (CallConnectionState = {}));
//# sourceMappingURL=types.js.map